var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back_live"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.$route.query.play_url,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }